import React, { useState, useMemo } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import '../../assets/css/auth.css';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = useMemo(() => params.get('token') || '', [params]);
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [err, setErr]   = useState('');
  const [msg, setMsg]   = useState('');
  const [loading, setLoad] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErr(''); setMsg('');
    if (!token) { setErr('Reset link is missing its token.'); return; }
    if (password.length < 6) { setErr('Password must be at least 6 characters.'); return; }
    if (password !== confirm) { setErr('Passwords do not match.'); return; }
    setLoad(true);
    try {
      const r = await api.post('/auth/reset-password', { token, newPassword: password });
      setMsg(r.data?.message || 'Password updated.');
      setTimeout(() => navigate('/login'), 2500);
    } catch (e2) {
      setErr(e2.response?.data?.error || 'Reset failed');
    } finally {
      setLoad(false);
    }
  }

  return (
    <div className="auth">
      <aside className="auth-aside">
        <Link to="/" className="auth-brand"><span className="mark" />EAHost</Link>
        <div className="auth-aside-body">
          <span className="auth-eyebrow">Account recovery</span>
          <h2 className="auth-headline">Set a new password.</h2>
          <p className="auth-sub">
            Choose a strong password you don't use anywhere else. You'll be signed back in afterwards.
          </p>
        </div>
        <span className="auth-foot">Running an EA carries substantial risk of loss.</span>
      </aside>

      <main className="auth-main">
        <div className="auth-card">
          <h1>Reset password</h1>
          <p className="auth-card-sub">Choose a new password for your account.</p>

          {err && <div className="auth-alert">{err}</div>}
          {msg && <div className="auth-alert is-success">{msg}</div>}
          {!token && (
            <div className="auth-alert">This page expects a reset token. Use the link from your email.</div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label htmlFor="password">New password</label>
              <input id="password" type="password" className="auth-input" placeholder="Min 6 characters"
                value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password" required />
            </div>
            <div className="auth-field">
              <label htmlFor="confirm">Confirm password</label>
              <input id="confirm" type="password" className="auth-input" placeholder="Repeat new password"
                value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password" required />
            </div>
            <button type="submit" className="auth-submit" disabled={loading || !token}>
              {loading ? 'Updating…' : 'Update password'}
            </button>
          </form>

          <p className="auth-switch">
            <Link to="/login" className="auth-link">← Back to sign in</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
